import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Typography, notification, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import Icon, {
} from '@ant-design/icons';
import { FaDownload } from 'react-icons/fa';
import moment from 'moment';

import { convertDataUSParaBrasilEHora, convertMoedaBRParaUS, validaDigitaçãoEFormataDinheiroBR } from './../../../../utils/Conversores';

import { useGetColumnSearchProps } from './../../../../hooks/FilterTable/stringCLearFiltros';
import { useGetColumnSearchPropsData } from './../../../../hooks/FilterTable/date';

import { useGetColumnSearchPropsObj } from '../../../../hooks/FilterTable/objString';
import RecibosCadastrarService from '../../../../services/http/services/Recibos/RecibosCadastrarService';
import { EmitError } from '../../../../utils/EmitError';
import useLocalStorage from '../../../../hooks/useLocalStorage';

const { Text } = Typography;

const IconDownload = (props: any) => <Icon {...props} component={FaDownload} ></Icon>

interface IUsuario {
    id: number;
    nome: string;
}

interface IReceipt {
    uuid: string;
    createdAt: string;
    updatedAt: string;
    id: number;
    id_recibo: string;
    siafi: string;
    cod_ibge: string;
    municipio: string;
    ano: string;
    mes: string;
    valor: string;
    extenso: string;
    userId: number;
    importId: number;
}

interface IDadosTable {
    id: number;
    nomeArquivo: string;
    tipo: string;
    userId: number;
    entityId: number;
    usuario: IUsuario;
    receipt: IReceipt[];
    created_at: string;
    updated_at: string;
}

interface DadosCidadesAll {
    "idIbge": number,
    "nome": string,
}

interface IReqCidades {
    "id": number,
    "uuid": string,
    "ibge_id_antigo": number,
    "nome": string,
    "uf": string,
    "latitude": string,
    "longitude": string,
    "populacao": number,
    "microrregiao": {
        "id": number,
        "uuid": string,
        "nome": string,
        "mesorregiao": {
            "id": number,
            "uuid": string,
            "nome": string,
            "estado": {
                "id": number,
                "uuid": string,
                "sigla": string,
                "nome": string,
                "populacao": number
            }
        }
    }
    "estadoId": number
}

export default function useCadastrar() {

    const navigate = useNavigate();
    const { getUserId } = useLocalStorage();

    const refController = useRef(new AbortController());
    const refFuncaoLimparFiltrosString = useRef<any>(null);

    const refContagemDoFiltro = React.useRef<Array<any>>([]);

    useEffect(() => {
        return () => {
            refController.current.abort();
        }
    }, []);


    const refForm = useRef<any>(null);

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<any>>([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [dadosTabelaState, setDadosTabelaState] = useState([]);
    const [hasSelectedAdd, setHasSelectedAdd] = useState(true);
    const [loadingFormAdd, setLoadingFormAdd] = useState(false);
    const [modalAddConfigVisible, setModalAddConfigVisible] = useState(false);

    const refDadosCidadesSelect = useRef<Array<IReqCidades>>([]);
    const [dadosCidadesSelect, setDadosCidadesSelect] = useState<Array<IReqCidades>>([]);
    const [loadingCidadesAndSetSelected, setLoadingCidadesAndSetSelected] = useState(false);

    const [valueRecibo, setValueRecibo] = useState<null | string>();

    //State de editar usuario
    const [initialValueEditId, setInitialValueEditId] = useState<undefined | number>(undefined);

    function gerarArrayAnos(anoInicial = 1980) {
        // Obter o ano atual
        const anoAtual = new Date().getFullYear();

        // Criar um array vazio para armazenar os anos
        const anos = [];

        // Loop do ano inicial até o ano atual
        for (let ano = anoInicial; ano <= anoAtual; ano++) {
            // Adicionar o ano ao array
            anos.push(ano);
        }

        // Retornar o array de anos
        return anos.sort((a, b) => b - a);
    }

    const selectCidadePorId = useCallback((id: number): IReqCidades | null => {
        let cidade: IReqCidades | null = null;
        refDadosCidadesSelect.current.forEach(val => {
            if (val.id == id) {
                cidade = val
            }
        });
        return cidade;

    }, []);

    const buscaAllCidadesAndSetSelected = useCallback(() => {
        const requestAsync = async () => {
            try {
                setLoadingCidadesAndSetSelected(true);

                const data = await RecibosCadastrarService.getCidades(refController.current.signal);

                refDadosCidadesSelect.current = data
                setDadosCidadesSelect(data)

                setLoadingCidadesAndSetSelected(false);
            } catch (error) {
                setLoadingCidadesAndSetSelected(false);
                let msgErro: any = (error as Error);
                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitError(error, true, 'addoredituser_dkwdfaiweyi')
                }
            }
        }

        requestAsync();

    }, []);

    const buscaRecibos = useCallback(() => {

        const requestAsync = async () => {
            try {
                setLoadingTable(true);

                let LSEntidade = JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null;

                const data = await RecibosCadastrarService.getRecibos(LSEntidade.entity.id, refController.current.signal);

                setDadosTabelaState(data);
                setLoadingTable(false);

            } catch (error) {
                setLoadingTable(false);
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel buscar os dados!',
                });
            }
        }

        requestAsync();

    }, []);

    //executa apenas ao iniciar o component
    useEffect(() => {

        refController.current = new AbortController();

        console.log(getUserId())
        // let arrayUrl = window.location.pathname.split("/");
        // VerificaRota(arrayUrl, navigate, true, validacaoPermissao(['import_files']));

        buscaRecibos();
        buscaAllCidadesAndSetSelected();

    }, []);


    const clickBotaoDeletarDados = useCallback((ativo: boolean): void => {
        const requestAsync = () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length === 1) {
                let obj: Array<object> = [];
                dadosTabelaState.forEach(({ nome, id, uuid }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid === val) {
                            obj.push({
                                id: id,
                                status: ativo
                            })
                        }
                    });

                })

                const excluirDadosModal = async () => {
                    try {

                        // await axios.patch(urlModulo, obj[0], {
                        //     //EXEMPLO APENAS PARA EXCLUIR UM [0] ATE CORRIGIR O BACK
                        //     headers: { 'Authorization': 'Bearer ' + getToken() }
                        // })

                        notification.success({
                            message: 'Sucesso',
                            description:
                                `Módulo ${ativo ? 'ativado' : 'inativado'} com sucesso!`,
                        });
                        setLoadingFormAdd(false);
                        buscaRecibos();
                        setInitialValueEditId(undefined);
                    } catch (error) {
                        setLoadingFormAdd(false);
                        notification.error({
                            message: 'Erro',
                            description:
                                'Não foi possivel Inativar, entre em contato com suporte!',
                        });
                    }
                }
                excluirDadosModal();
                setHasSelectedAdd(true);
                setSelectedRowKeys([]);

            }
        }

        requestAsync();

    }, [selectedRowKeys, dadosTabelaState, buscaRecibos]);


    const clickCancelModalAddConfig = useCallback(() => {
        setModalAddConfigVisible(false);
        refForm.current.resetFields();
    }, []);

    const clickSubmitModalAddConfig = useCallback((): void => {
        refForm.current?.validateFields()
            .then((values: any) => {
                setLoadingFormAdd(true);


                let LSEntidade = JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null;

                values.municipio = selectCidadePorId(Number(values.cidades))?.nome
                values.cod_ibge = values.cidades.toString()


                values.entityId = LSEntidade.entity.id

                //verifica se ele esta editando ou é um novo
                if (initialValueEditId) {
                    values.id = initialValueEditId;

                    const editarModalSubmit = async () => {
                        try {

                            const data = await RecibosCadastrarService.putRecibos(initialValueEditId, values, refController.current.signal);

                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram editados com sucesso!',
                            });

                            setLoadingFormAdd(false);
                            buscaRecibos();
                            clickCancelModalAddConfig();
                            setInitialValueEditId(undefined);
                            setValueRecibo(undefined)

                        } catch (error) {
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    editarModalSubmit();
                } else {
                    const salvarDadosModalSubmit = async () => {
                        try {
                            const data = await RecibosCadastrarService.postRecibos(values, refController.current.signal);

                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram criados com sucesso!',
                            });

                            setLoadingFormAdd(false);
                            buscaRecibos();
                            clickCancelModalAddConfig();
                        } catch (error) {
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    salvarDadosModalSubmit();
                }
                setHasSelectedAdd(true);
                setSelectedRowKeys([])

            })
            .catch((errorInfo: any) => {

                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatórios!',
                });
            });
    }, [initialValueEditId, clickCancelModalAddConfig, buscaRecibos]);

    //abrir modal
    const clickBotaoAdd = useCallback((): void => {
        setInitialValueEditId(undefined);
        setModalAddConfigVisible(true);
    }, []);

    //Editar dados
    const clickBotaoEditar = useCallback((): void => {

        const requestAsync = () => {

            if (selectedRowKeys.length === 1) {
                let obj: Array<any> = [];
                dadosTabelaState.forEach((objEditar: any): void => {
                    if (objEditar.id == selectedRowKeys[0]) {
                        obj.push(objEditar)
                    }
                })

                if (refForm.current) {
                    refForm.current.setFieldsValue(
                        {
                            id_recibo: obj[0].id_recibo,
                            siafi: obj[0].siafi,
                            cidades: Number(obj[0].cod_ibge),
                            ano: obj[0].ano,
                            mes: obj[0].mes,
                            valor: obj[0].valor,
                            extenso: obj[0].extenso,

                        }
                    );
                } else {
                    setTimeout(() => {
                        refForm.current?.setFieldsValue(
                            {
                                id_recibo: obj[0].id_recibo,
                                siafi: obj[0].siafi,
                                cidades: Number(obj[0].cod_ibge),
                                ano: obj[0].ano,
                                mes: obj[0].mes,
                                valor: obj[0].valor,
                                extenso: obj[0].extenso,
                            }
                        );
                    }, 100);
                }

                setValueRecibo(obj[0].id_recibo)
                setInitialValueEditId(obj[0].id)
                setModalAddConfigVisible(true);

            }
        }

        requestAsync();

        setModalAddConfigVisible(true);
    }, [selectedRowKeys, dadosTabelaState, refForm]);

    useEffect(() => {
        const requestAsync = async () => {
            try {
                if (selectedRowKeys.length === 1) {
                    let obj: Array<any> = [];
                    dadosTabelaState.forEach((objEditar: any): void => {
                        if (objEditar.id.toString() === selectedRowKeys[0]) {
                            obj.push(objEditar)
                        }
                    })

                }


            } catch (error) {

            }
        }

        requestAsync();

    }, [selectedRowKeys]);


    const onclickTable = useCallback((record: any, row: any): void => {

        //verifica se nome esta no array
        if (selectedRowKeys.includes(record.id.toString())) {
            let filter = selectedRowKeys.filter((val) => {
                return val.toString() !== record.id.toString()
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(false);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(true);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length === 0) {
                setSelectedRowKeys([record.id.toString()]);
                setHasSelectedAdd(false);
            } else {
                let teste = selectedRowKeys.concat(record.id.toString());
                setSelectedRowKeys(teste);
                setHasSelectedAdd(false);
            }
        }
    }, [selectedRowKeys]);


    const onSelectChange = useCallback((rowKeys: Array<string>): void => {
        if (rowKeys.length > 1) {
            setSelectedRowKeys(rowKeys);
            setHasSelectedAdd(false);
        } else if (rowKeys.length === 0) {
            setSelectedRowKeys(rowKeys);
            setHasSelectedAdd(true);
        } else {
            setSelectedRowKeys(rowKeys);
            setHasSelectedAdd(true);
        }
    }, [selectedRowKeys, setSelectedRowKeys]);

    const rowSelection: any = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    const onClickVoltarConfigOfSystem = useCallback((): void => {
        navigate("/configuracoesdosistema");
    }, [navigate]);


    const onChangeMoney = useCallback((e: any) => {

        refForm.current.setFieldsValue(
            { valor: validaDigitaçãoEFormataDinheiroBR(e.target.value) }
        );

    }, []);

    const clickBtnBaixarRecibo = useCallback((id: number, item?: IReceipt) => {

        const buscaXLSX = async () => {
            try {
                setLoadingTable(true)

                const data = await RecibosCadastrarService.getPrintRecibos(id, refController.current.signal);

                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;

                link.setAttribute('download', `recibo_${item?.municipio}_${item?.mes}_${item?.ano}.pdf`);
                document.body.appendChild(link);
                link.click();

                setLoadingTable(false)

            } catch (error) {
                setLoadingTable(false)

                EmitError(error, true, 'relatorioconsolidado_dkwdfaiweyi')

            }
        }

        buscaXLSX();

    }, []);

    const columns = [
        // {
        //     title: 'Id Recibo',
        //     dataIndex: 'id_recibo',
        //     ...useGetColumnSearchProps('id_recibo', refFuncaoLimparFiltrosString),
        //     width: '9%',
        //     sorter: (a: any, b: any) => a?.id_recibo?.localeCompare(b?.id_recibo),
        //     showSorterTooltip: false,
        // },
        {
            title: 'SIAFI',
            dataIndex: 'siafi',
            ...useGetColumnSearchProps('siafi', refFuncaoLimparFiltrosString),
            width: '6%',
            sorter: (a: any, b: any) => a?.siafi?.localeCompare(b?.siafi),
            showSorterTooltip: false,
            render: (siafi: any) => {

                return siafi
            },
        },
        {
            title: 'Município',
            dataIndex: 'municipio',
            ...useGetColumnSearchProps('municipio', refFuncaoLimparFiltrosString),
            width: '10%',
            sorter: (a: any, b: any) => a?.municipio?.localeCompare(b?.municipio),
            showSorterTooltip: false,
            render: (municipio: any) => {

                return municipio
            },
        },
        {
            title: 'Valor (R$)',
            dataIndex: 'valor',
            ...useGetColumnSearchProps('valor', refFuncaoLimparFiltrosString),
            width: '8%',
            sorter: (a: any, b: any) => a?.valor?.localeCompare(b?.valor),
            showSorterTooltip: false,
            render: (valor: any) => {

                return valor
            },
        },
        {
            title: 'Ano',
            dataIndex: 'ano',
            ...useGetColumnSearchProps('ano', refFuncaoLimparFiltrosString),
            width: '1%',
            sorter: (a: any, b: any) => a?.ano?.localeCompare(b?.ano),
            showSorterTooltip: false,
            render: (ano: any) => {

                return ano
            },
        },
        {
            title: 'Mês',
            dataIndex: 'mes',
            ...useGetColumnSearchProps('mes', refFuncaoLimparFiltrosString),
            width: '1%',
            sorter: (a: any, b: any) => a?.mes?.localeCompare(b?.mes),
            showSorterTooltip: false,
            render: (mes: any) => {

                return mes
            },
        },
        {
            title: 'Usuário',
            dataIndex: 'usuario',
            ...useGetColumnSearchPropsObj('usuario'),
            width: '10%',
            sorter: (a: any, b: any) => a?.usuario?.nome.localeCompare(b?.usuario?.nome),
            showSorterTooltip: false,
            render: (usuario: any) => {

                return usuario?.nome
            },
        },
        // {
        //     title: 'Validade',
        //     dataIndex: 'dataValidade',
        //     ...useGetColumnSearchPropsData('dataValidade'),
        //     width: '2%',
        //     sorter: (a: any, b: any) => {

        //         let aMonMen: any = null
        //         let bMonMen: any = null
        //         if (a.dataValidade) {
        //             aMonMen = moment(a.dataValidade).unix()
        //         } else {
        //             aMonMen = 0
        //         }
        //         if (b.dataValidade) {
        //             bMonMen = moment(b.dataValidade).unix()
        //         } else {
        //             bMonMen = 0
        //         }

        //         return aMonMen - bMonMen
        //     },
        //     showSorterTooltip: false,
        //     // sorter: (a: any, b: any) => a.dataValidade.localeCompare(b.dataValidade),
        //     render: (criado: any, record: any) => {
        //         return (
        //             <div
        //                 style={{
        //                     display: 'flex',
        //                     justifyContent: 'space-between',
        //                     alignItems: 'center'
        //                 }}
        //             >

        //                 <Text>
        //                     {
        //                         criado ? convertDataUSParaBrasil(criado) : '-'
        //                     }
        //                 </Text>

        //                 {/* <img style={{
        //                     width: 20,
        //                     marginLeft: 5
        //                 }} src={record.status ? ImgDownLike : ImgUpLike} /> */}
        //             </div>
        //         )
        //     },
        // },
        {
            title: 'Data Importação',
            dataIndex: 'importacao',
            // ...useGetColumnSearchPropsData('created_at'),
            width: '2%',
            // sorter: (a: any, b: any) => {

            //     let aMonMen: any = null
            //     let bMonMen: any = null
            //     if (a.created_at) {
            //         aMonMen = moment(a?.created_at)?.unix()
            //     } else {
            //         aMonMen = 0
            //     }
            //     if (b.created_at) {
            //         bMonMen = moment(b?.created_at)?.unix()
            //     } else {
            //         bMonMen = 0
            //     }

            //     return aMonMen - bMonMen
            // },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.update_at.localeCompare(b.update_at),
            render: (importacao: any) => {

                return (
                    convertDataUSParaBrasilEHora(importacao?.data_import)
                )
            },
        },
        {
            title: 'Criado em',
            dataIndex: 'created_at',
            ...useGetColumnSearchPropsData('created_at'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.created_at) {
                    aMonMen = moment(a?.created_at)?.unix()
                } else {
                    aMonMen = 0
                }
                if (b.created_at) {
                    bMonMen = moment(b?.created_at)?.unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.update_at.localeCompare(b.update_at),
            render: (data: any) => {

                return (
                    convertDataUSParaBrasilEHora(data)
                )
            },
        },
        {
            title: '',
            dataIndex: 'id',
            width: '2%',
            showSorterTooltip: false,
            render: (id: number, record: IReceipt) => {
                return (
                    <div className='naoElinha'>
                        {
                            id ?
                                <Button
                                    type="primary"
                                    className="botaoNaolinha"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        clickBtnBaixarRecibo(id, record)
                                    }}
                                >
                                    {'Baixar '}<IconDownload />
                                </Button>
                                :
                                <Text
                                    style={{
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {'Não há arquivo.'}
                                </Text>
                        }

                    </div>
                )
            },
        },
    ];

    return {
        columns,
        dadosTabelaState,
        refContagemDoFiltro,
        loadingFormAdd,
        loadingTable,
        onclickTable,
        rowSelection,
        modalAddConfigVisible,
        clickBotaoAdd,
        clickBotaoEditar,
        hasSelectedAdd,
        clickSubmitModalAddConfig,
        clickCancelModalAddConfig,
        refForm,
        loadingCidadesAndSetSelected,
        dadosCidadesSelect,
        gerarArrayAnos,
        onChangeMoney,
        valueRecibo
    }
}
